import { type FC, useRef } from 'react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useOnClickOutside } from 'usehooks-ts';

import SettingsSection from '@/components/Settings/SettingsSection/SettingsSection';
import { toggleSettingMenu } from '@/redux/reducers/modalsReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

const BurgerSettingsModal: FC = () => {
  const ref = useRef(null);
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector((state) => state.modals.settingsIsOpen);

  useOnClickOutside(ref, () => dispatch(toggleSettingMenu()));

  return (
    <AnimatePresence propagate>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ ease: 'easeIn', duration: 0.1 }}
          className={cn(
            'absolute top-0 left-0 w-full h-[100svh] z-[11]',
            css.background,
          )}
        >
          {isOpen && (
            <motion.div
              ref={ref}
              style={{ marginTop: 'var(--header-height)' }}
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ ease: 'easeIn', duration: 0.1 }}
              className="ml-4 mr-[4.875rem]"
            >
              <SettingsSection onClose={() => dispatch(toggleSettingMenu())} />
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BurgerSettingsModal;
